import { Link, useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CalendarDays, FileText, Home, LogOut, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { clearMeSession, getMeSession } from "@/lib/auth/storage";
import { sessionIsYoga } from "@/lib/types";

const allLinks = [
  { href: "/me", label: "Today", icon: Home, exact: true },
  { href: "/me/notice", label: "Notice", icon: FileText },
  { href: "/me/mantras", label: "Mantras", icon: BookOpen, yogaOnly: true },
  { href: "/me/history", label: "History", icon: CalendarDays },
];

export function MeHeader() {
  const person = getMeSession();
  const navigate = useNavigate();
  const firstName = person?.name?.split(" ")[0];

  return (
    <header className="flex shrink-0 items-center justify-between gap-3 border-b bg-white px-4 py-3">
      <div className="min-w-0">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-saffron-700">
          BCEC Attendance
        </p>
        <h1 className="truncate text-lg font-semibold">
          {firstName ? `Hare Krishna, ${firstName}` : "My Attendance"}
        </h1>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="shrink-0 text-muted-foreground"
        onClick={() => {
          clearMeSession();
          navigate("/me/login");
        }}
      >
        <LogOut className="h-4 w-4" />
        Logout
      </Button>
    </header>
  );
}

export function MeBottomNav() {
  const { pathname } = useLocation();
  const person = getMeSession();
  const isYoga = sessionIsYoga(person);
  const links = allLinks.filter((l) => !("yogaOnly" in l && l.yogaOnly) || isYoga);

  return (
    <nav className="shrink-0 border-t bg-white pb-safe">
      <div className="mx-auto flex max-w-lg items-stretch justify-around">
        {links.map(({ href, label, icon: Icon, exact }) => {
          const active = exact ? pathname === href : pathname.startsWith(href);
          return (
            <Link
              key={href}
              to={href}
              className={cn(
                "flex flex-1 flex-col items-center gap-1 py-3 text-xs font-medium",
                active ? "text-saffron-700" : "text-muted-foreground"
              )}
            >
              <Icon className="h-5 w-5" />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
